import { EventEmitter, Injectable } from "@angular/core";
import { AxiosService, AxiosServiceReturn } from "../../_services/axios.service";

@Injectable({
    providedIn: 'root'
})
export class HomeService {


    constructor(
        private axiosService: AxiosService,
    ) { }

    async getOverallAllStructure() {
        const res: AxiosServiceReturn = await this.axiosService.request(
            "GET",
            'api/get-overall-structure',
            null,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: false
                    }
                }
            }

        );
        return res;
    }

    async getReport() {
        const res: AxiosServiceReturn = await this.axiosService.request(
            "GET",
            'api/report',
            null,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: false
                    }
                }
            }

        );
        return res;
    }

    async getCurriculumDocument(id : string) {
        const res: AxiosServiceReturn = await this.axiosService.request(
            "GET",
            `api/get-curriculum-document/${id}`,
            null,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: false
                    }
                }
            }

        );
        return res;
    }


    buttonClickEvent: EventEmitter<any> = new EventEmitter<any>();

    openDocument(data: any): void {
      this.buttonClickEvent.emit(data);
    }




    async sendComparingCurriculums(data : any){
        const res: AxiosServiceReturn = await this.axiosService.request(
            "POST",
            `api/send-comparing-curriculums`,
            data,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: false
                    }
                }
            }

        );


        return res;
    }


    async getOverAllCourseReport(){
        const res: AxiosServiceReturn = await this.axiosService.request(
            "GET",
            `api/get-courses-report`,
            null,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: false
                    }
                }
            }

        );
        return res;
    }

    async getOverAllProgramReport(){
        const res: AxiosServiceReturn = await this.axiosService.request(
            "GET",
            `api/get-programs-report`,
            null,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: false
                    }
                }
            }

        );
        return res;
    }


    async registerUser(data :any){
        const res: AxiosServiceReturn = await this.axiosService.request(
            "POST",
            `api/auth/register`,
            data,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: true
                    }
                }
            }
        );
        return res;

    }


    async editUserProfile(id :string , data :any){
        const res: AxiosServiceReturn = await this.axiosService.request(
            "PUT",
            `api/edit-user/${id}`,
            data,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: true
                    }
                }
            }
        );
        return res;
    }



    async deleteUser(id :string){
        const res: AxiosServiceReturn = await this.axiosService.request(
            "DELETE",
            `api/delete-user/${id}`,
            null,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: true
                    }
                }
            }
        );
        return res;

    }


    

    async getAllUsers(){
        const res: AxiosServiceReturn = await this.axiosService.request(
            "GET",
            `api/get-all-users`,
            null,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: false
                    }
                }
            }

        );
        return res;
    }


    async addRole(data :any){
        const res: AxiosServiceReturn = await this.axiosService.request(
            "POST",
            `api/add-role`,
            data,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: true
                    }
                }
            }
        );
        return res;
    }


    async editRole(id :string, data :any){

        const res: AxiosServiceReturn = await this.axiosService.request(
            "PUT",
            `api/edit-role/${id}`,
            data,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: true
                    }
                }
            }
        );
        return res;

    }


    async deleteRole(id :string){
        const res: AxiosServiceReturn = await this.axiosService.request(
            "DELETE",
            `api/delete-role/${id}`,
            null,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: true
                    }
                }
            }
        );
        return res;

    }


    async getAllRoles(){
        const res: AxiosServiceReturn = await this.axiosService.request(
            "GET",
            `api/get-all-roles`,
            null,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: false
                    }
                }
            }

        );
        return res;
    }



    async approveCurriculum(data : any){
        const res: AxiosServiceReturn = await this.axiosService.request(
            "POST",
            'api/approve-curriculum',
            data,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: false
                    }
                }
            }
        );
        return res;
    }


    async countCoursesFromSelectedPrograms(data : any){
        const res: AxiosServiceReturn = await this.axiosService.request(
            "POST",
            'api/count-courses-from-selected-programs',
            data,
            {
                notificationConfig: {
                    successHandlingConfig: {
                        showGlobalSuccessMessageNotification: false
                    }
                }
            }
        );
        return res;
    }

    
   
}